export default __webpack_public_path__ + "static/media/supply-green-dispatch.477f32d0.svg";